<script lang="ts" setup>
import { texts } from '@/config/brands'

const appStoreUrl = texts?.appStoreUrl || '#'
const googlePlayUrl = texts?.googlePlayUrl || '#'
</script>

<template>
  <div class="flex flex-col" style="gap: 16px">
    <h4 style="font-weight: bold; font-size: 22px; color: #FFFFFF; margin: 0">
      Download App
    </h4>
    <div class="flex flex-col" style="gap: 12px">
      <a :href="appStoreUrl" target="_blank" rel="noopener noreferrer" style="display: inline-block; width: 114px; height: 34px; flex-shrink: 0">
        <img src="/landing-page/w2a/2/badge-apple.svg" alt="App Store" style="width: 114px; display: block; object-fit: contain">
      </a>
      <a :href="googlePlayUrl" target="_blank" rel="noopener noreferrer" style="display: inline-block; width: 114px; height: 34px; flex-shrink: 0">
        <img src="/landing-page/w2a/2/badge-google.svg" alt="Google Play" style="width: 114px; height: 34px; display: block; object-fit: contain">
      </a>
    </div>
  </div>
</template>
